import { UrlService } from '../../services/state/url.service';

/**
 * robuste Konkatenation von UrlParametern aus String oder Number-Arrays
 */
export function createValidUrlParameter(paramsAsArray: string[] | number[]): string | null {
  if (paramsAsArray === null || paramsAsArray === undefined) {
    return null;
  }
  return paramsAsArray.length !== 0 ? paramsAsArray.join(UrlService.VALUE_SEPARATOR) : null;
}
